import instance from '@apis/instance';
import { PayUInfoResponse } from '@models/easyCard';

class EasyCardApi {
    static getPayUInfo(): Promise<PayUInfoResponse> {
        return instance.get('/v0/easy-card/payu');
    }
}

export default EasyCardApi;
